import { t } from 'i18next'

import { ServerValidationError } from '@/shared/lib/errors/ServerValidationError'

import { wwtErrorLog } from '../../logger/wwtErrorLog'
import { ErrorHandlerResult } from '../../types/ErrorHandlerResult'
import { getRandomMessage } from '../getRandomMessage'

export const serverValidationErrorHandler = (
	error: ServerValidationError
): ErrorHandlerResult => {
	wwtErrorLog(
		`Server validation error in block ${error.blockName}\n`,
		'Validation errors',
		JSON.parse(error.message),
		'Original response: ',
		error.originalData
	)

	wwtErrorLog(
		`Server validation error in block ${error.blockName}, Zod unformatted message:`,
		error.message
	)

	const messages = t('server.validation', {
		ns: 'errors',
		name: error.blockName,
		returnObjects: true
	})
	const { title, description } = getRandomMessage(messages)

	return {
		reset: true,
		toastInfo: {
			id: `server-validation-${error.message}`,
			title,
			description,
			variant: 'serverFailure'
		}
	}
}
